import React, { useEffect, useRef, useState } from "react"
import { Card, CardBody } from "reactstrap"
import SyncfusionGrid from "components/custom/Syncfusion/SyncfusionGrid"

const EnterprisesGrid = ({ userEnterprise, enterprises, props }) => {

  const handleEnterprisePress = (e, enterprise) => {
    e && e.preventDefault()
    props.history.push(`/editEnterprise/${enterprise.enterpriseID}`)
  }

  const columns = [
    {
      headerText: "Enterprise",
      field: "enterpriseName",
      template: data => (
        <a href="#" onClick={e => handleEnterprisePress(e, data)}>
          {data.enterpriseName}
        </a>
      ),
    },
    {
      headerText: "# of Users",
      field: "numActiveUsers",
    },
    {
      headerText: `# of ${
        userEnterprise != null && userEnterprise.modelLabel
      }s`,
      field: "numScenarios",
    },
  ]
  return (
    <Card>
      <CardBody>
        {enterprises.length > 0 && (
          <>
            {/* <button
              onClick={toggleFilters}
              className="btn btn-outline-primary"
              style={{ float: "right" }}
            >
              {showFilters ? "Hide" : "Show"} <i className="fas fa-search"></i>{" "}
              <i className="fas fa-filter"></i>
            </button> */}
            <SyncfusionGrid columns={columns} data={enterprises} />
          </>
        )}
      </CardBody>
    </Card>
  )
}

export default EnterprisesGrid
